
import {
  Calendar, Heart, Building2, Handshake, Brain, Leaf, Activity, Scale, Dumbbell, Baby,
  Zap, Star, Users, Shield, Sparkles, Stethoscope, Target, Award, TrendingUp,
  Clock, Globe, CheckCircle, Apple, Coffee, Salad, Utensils, type LucideIcon,
} from "lucide-react";
import { useServicesContent } from "@/hooks/useServicesContent";
import { openGoogleCalendar } from "@/lib/utils";

const iconMap: Record<string, LucideIcon> = {
  Heart, Building2, Handshake, Brain, Leaf, Activity, Scale, Dumbbell, Baby,
  Zap, Star, Users, Shield, Sparkles, Stethoscope, Target, Award, TrendingUp,
  Clock, Globe, CheckCircle, Apple, Coffee, Salad, Utensils, Calendar,
};

interface AdditionalServicesProps {
  onSchedule: (serviceType: string) => void;
}

export function AdditionalServices({ onSchedule }: AdditionalServicesProps) {
  const { content, loading } = useServicesContent("additional_services");

  if (loading) {
    return (
      <div className="grid sm:grid-cols-2 gap-4">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="h-24 bg-gray-100 rounded-2xl animate-pulse" />
        ))}
      </div>
    );
  }

  const additionalServices = content
    .filter((item) => item.is_active)
    .map((item) => item.content_value as Record<string, string>);

  if (!additionalServices.length) return null;

  return (
    <div>
      <div className="text-center mb-8">
        <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">Mais opções</p>
        <h2 className="text-2xl font-bold text-gray-800 font-primary">Serviços Adicionais</h2>
      </div>

      <div className="grid sm:grid-cols-2 gap-4">
        {additionalServices.map((service, index) => {
          const Icon = iconMap[service.icon] || Calendar;
          return (
            <div
              key={index}
              className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-200 px-6 py-5 flex items-center gap-5"
            >
              <div className="w-10 h-10 bg-brand-primary/8 rounded-xl flex items-center justify-center shrink-0">
                <Icon className="w-5 h-5 text-brand-primary" />
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-bold text-gray-800 font-primary leading-snug mb-0.5">
                  {service.title || "Serviço"}
                </h3>
                {service.description && (
                  <p className="text-xs text-gray-500 leading-relaxed">{service.description}</p>
                )}
              </div>

              <button
                onClick={() => service.serviceType ? onSchedule(service.serviceType) : openGoogleCalendar()}
                className="shrink-0 flex items-center gap-1.5 bg-brand-primary hover:bg-brand-primary/90 text-white font-primary font-semibold text-xs rounded-xl px-3.5 py-2 transition-colors shadow-sm"
              >
                Agendar
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
